import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/client',
      redirect: to => to.query.id
        ? { path: '/auth/client', query: { id: to.query.id } }
        : '/auth/client',
    },
    ...setupLayouts(routes),
  ],
})
